import React from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';

function HandsOnCTA() {
    return (
        <Box sx={{ background: '#1f1f1f', pt: 4 }}>
            <Container>
                <Grid container alignItems="center">
                    <Grid item sm={9} xs={12}>
                        <Typography variant="h4" component="h2" gutterBottom sx={{ color: '#fff' }}>
                            Take Your Skills to the Next Level
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: '#e0e0e0' }}>
                            Join our specialized training programs designed to give you in-depth knowledge and hands-on experience in
                            cybersecurity, cloud engineering, and more.
                        </Typography>
                    </Grid>
                    <Grid item sm={3} xs={12} sx={{ textAlign: { xs: 'center', sm: 'right' }, mt: { xs: 2, sm: 0 } }}>
                        <Button
                            href="/apply"
                            target="_blank"
                            variant="contained" color="primary" size="large"
                            sx={{ fontWeight: 'bold', color: '#fff' }}>
                            Enroll Now
                        </Button>
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        width: '92%',
                        pt: 4,
                        borderBottom: '1px solid #888',
                        margin: '0 auto',
                    }}
                />
            </Container>
        </Box>
    );
}

export default HandsOnCTA;
